// The top of every confirmation panel (Jade, 2026-10-21, from a reference she
// picked): an icon in a filled circle, one bold question, and one short line
// under it. No extra warnings: keep panels to this.
// - Delete / remove (default): red circle, trash icon, "This action can't be undone."
// - Any other confirmation (2026-10-22): pass `icon` (a lucide icon) and
//   tone="accent" for a circle in the app's accent, with its own subtitle.
//   Pair with CONFIRM_PRIMARY (accent) or CONFIRM_DANGER (red) buttons.
import { Trash2 } from "lucide-react";

const TONES = {
  danger: { bg: "#e53935", ink: "#fff", shadow: "0 6px 18px rgba(229,57,53,0.3)" },
  accent: { bg: "var(--c-primary)", ink: "var(--c-on-primary, #fff)", shadow: "0 6px 18px color-mix(in srgb, var(--c-primary) 35%, transparent)" },
};

// `compact`: a smaller circle and icon, for panels that carry more below the
// question (the Skip panels' calendar, Jade 2026-10-26).
export default function ConfirmHeader({ title, subtitle = "This action can't be undone.", icon: Icon = Trash2, tone = "danger", compact = false }) {
  const t = TONES[tone] || TONES.danger;
  const circle = compact ? 46 : 64;
  return (
    <div style={{ textAlign: "center", marginBottom: 22 }}>
      <div className="keep-white" style={{ width: circle, height: circle, borderRadius: "50%", background: t.bg, color: t.ink, display: "flex", alignItems: "center", justifyContent: "center", margin: `0 auto ${compact ? 12 : 16}px`, boxShadow: t.shadow }}>
        <Icon size={compact ? 20 : 30} color={t.ink} />
      </div>
      <div style={{ fontSize: 17, fontWeight: 800, color: "var(--c-text)", lineHeight: 1.35, marginBottom: subtitle ? 6 : 0 }}>{title}</div>
      {subtitle && <div style={{ fontSize: 13, color: "var(--c-text-soft)", lineHeight: 1.5 }}>{subtitle}</div>}
    </div>
  );
}
